'use client';

import ProductHeroImage from 'src/components/ProductHeroImage';
import React, { useState } from 'react';
import { ProductDetailPageProps } from '@/types/ProductDetailPageProps';
import ProductMainInfo from '@/components/ProductMainInfo';
import ProductAdditionalInfo from '@/components/ProductAdditionalInfo';
import ProductCarousel from "src/components/ProductCarousel";
import { pseudoI18n } from "@/i18n/pseudoI18n";
import { ThemeContext } from "@/providers/ThemeContext";
import Breadcrumb from '@/components/Breadcrumb';
import { BreadcrumbBlock } from '@/payload-types';
import { PATHS } from '@/constants/paths';
import ProductInfoTab from '@/components/ProductAdditionalInfo/ProductInfoTab';
import ProductKeyFeatures from '@/components/ProductKeyFeatures';


export default function ProductDetailClient( props: ProductDetailPageProps ) {
  const { product, visitedProducts, theme, setting } = props;
  const { images, variants } = product || {};

  const [ selectedVariant, setSelectedVariant ] = useState<string>( '' );

  const { t } = pseudoI18n();

  let categoryBreadcrumb: { link: { label: string; url: string; }; } | undefined = undefined;
  const category = product.categories?.[0];
  if (typeof category === 'object') {
    categoryBreadcrumb = {
      link: {label: category.title, url: `${PATHS.COLLECTIONS}/${category.slug}`}
    };
  }

  const breadcrumbs = {
    blockType: 'breadcrumbBlock',
    breadcrumb: [
      { link: { label: t('Home'), url: PATHS.HOME } },
      categoryBreadcrumb,
      { link: { label: product.productName, url: '' } },
    ].filter(Boolean),
  } as BreadcrumbBlock;

  return (
    <ThemeContext value={ theme || {id: ''} }>
      <Breadcrumb links={breadcrumbs} />
      <div className='container my-ml md:my-lg'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-md md:gap-lg'>
          <ProductHeroImage
            list={ images }
            variants={ variants }
            selectedVariant={ selectedVariant }
            className='row-span-2'
          />
          <div>
            <ProductMainInfo
              { ...props }
              setSelectedVariant={ setSelectedVariant }
              selectedVariant={ selectedVariant }
            />
            <ProductAdditionalInfo { ...props } />
            <ProductKeyFeatures {...(setting?.product || {})} />
            <ProductInfoTab product={product} />
          </div>
        </div>
        <ProductCarousel products={ visitedProducts } label={ t( 'Recently viewed' ) }/>
      </div>
    </ThemeContext>
  );
}
